import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {numericWord} from "../../utils/formatters";

class SearchStatistics extends Component {
    static propTypes = {
        totalCount: PropTypes.number.isRequired,
        categoryCount: PropTypes.number.isRequired
    };
    static defaultProps = {};
    state = {};

    render() {
        const {totalCount, categoryCount} = this.props;
        return (
            <div className="page-wide-block">
                <div className="box m-a-0 border-radius-0 valign-top">
                    <div className="box-cell col-md-9 p-y-2">
                        <div className="box-container">
                            <div className="box-cell p-x-3 b-r-1">
                                <div className="font-weight-bold font-size-18">{totalCount}</div>
                                <div className="font-weight-semibold font-size-11 text-muted text-uppercase">
                                    {numericWord(totalCount, 'Запись найдена', 'Записи найдено', 'Записей найдено')}
                                </div>
                            </div>
                            <div className="box-cell p-x-3 b-r-1">
                                <div className="font-weight-bold font-size-18">{categoryCount}</div>
                                <div className="font-weight-semibold font-size-11 text-muted text-uppercase">
                                    {numericWord(categoryCount, 'Раздел', 'Раздела', 'Разделов')}
                                </div>
                            </div>
                            <div className="box-cell p-x-3 b-r-1">
                                {/*<div className="font-weight-bold font-size-18">0.838 секунд</div>*/}
                                {/*<div className="font-weight-semibold font-size-11 text-muted text-uppercase">Время поиска</div>*/}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default SearchStatistics;


// WEBPACK FOOTER //
// ./src/pages/OmniSearch/SearchStatistics.js